import React, { useState, useEffect } from 'react';
import {
  Modal,
  Fade,
  Typography,
  Box,
  Backdrop,
  Button,
  IconButton,
  TextField,
  Autocomplete,
  Paper,
  FormControl,
  InputLabel,
  InputAdornment,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { LoadingButton } from '@mui/lab';
import { API, graphqlOperation } from 'aws-amplify';
import { axiosInstanceForLambda } from '../../../library/Axios';
import { showSuccessSnackbar, showWarningSnackbar } from '../../../components/snackBar/snakbar';
import { useDispatch, useSelector } from 'react-redux';
import { einvAuth, einvAuthData, einvId, einvPreview } from '../../../redux/reducers/eInvReducer';
import { Visibility, VisibilityOff } from '@mui/icons-material';
import API_ENDPOINTS from '../../../apiEndpoints';
import CheckBoxWithLabel from '../../../components/formElements/CheckBoxWithLabel';
import { createcompanydetails } from '../../../graphql';
import { useLocation, useNavigate } from 'react-router-dom';
import { fetchCompany } from '../../../redux/reducers/CompanySlice';
const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  boxShadow: 24,
  outline: 'none',
  minWidth: '500px',
};
function EInvAuth({
  open,
  setOpen,
  action,
  listEway,
  // setPreviewOpen,
  setBackdropOpen,
  allSales,
  rowData,
  authOk,
  setCancelEInv,
  checkbox,
  onComplete,
}) {
  console.log(checkbox, 'checkbox');
  const location = useLocation();
  const loc = location.pathname.includes('purchase');
  console.log(loc, 'loccc');

  const [userName, setUserName] = useState('');
  const [bool, setBool] = useState(false);
  const [userPassword, setUserPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [connect, setConnect] = useState(false);
  const [showPassword, setshowPassword] = useState(false);
  const endAdornment = (
    <InputAdornment position="end">
      <IconButton
        aria-label="toggle password visibility"
        onClick={() => setshowPassword((prev) => !prev)}
        edge="end"
        className="adornmentIconBtn"
      >
        {showPassword ? <VisibilityOff /> : <Visibility />}
      </IconButton>
    </InputAdornment>
  );

  let dispatch = useDispatch();
  const navigate = useNavigate();
  let getCompany = useSelector((state) => state?.companyReducer?.companyDetails);
  console.log(getCompany, 'getCompany');
  const handleClose = (event, reason) => {
    setOpen(false);
    // if (listEway === true) {
    // }
    if (loc === false && !listEway) {
      navigate('/salesInvoiceReport');
    }
    dispatch(einvAuthData({}));
    dispatch(einvId(false));
    setUserName('');
    setUserPassword('');
    setBool(false);
    setConnect(false);
  };
  useEffect(() => {
    if (getCompany?.einvoiceusername) {
      setUserName(getCompany?.einvoiceusername);
    }
  }, [open]);

  useEffect(() => {
    const handleKeyDown = (event) => {
      if ((event.ctrlKey || event.metaKey) && event.key === 's' && open) {
        event.preventDefault();
        handleEimp();
      }
    };
    window.addEventListener('keydown', handleKeyDown);
    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [userName, userPassword, open]);

  const companyUpdate = async () => {
    const compData = getCompany?.relatedcompanydetailsnew[0];
    const companyFormData = {
      ewaybillconnect: checkbox === 'eway' ? 1 : compData.ewaybillconnect,
      einvoiceconnect: checkbox === 'invoice' ? 1 : compData.einvoiceconnect,
      companyshort: compData.companyshort,
      companylegalname: compData.companylegalname,
      lutbondtodate: compData.lutbondtodate,
      invoicedetailapplicablefromdate: compData.invoicedetailapplicablefromdate,
      tdsapplicable: 0,
      gstcategory: compData.gstcategory,
      financialyearid: compData.financialyearid,
      financialyearstartandendmonth: compData.financialyearstartandendmonth,
      expiredtimestamp: 0,
      websiteurl: compData.websiteurl,
      currencycd: compData.currencycd,
      accountinventoryflag: compData.accountinventoryflag,
      pannumber: compData.pannumber,
      tdstcsnumber: compData.tdstcsnumber,
      emailaddress: getCompany.relatedemailcontacts[0]?.emailaddress,
      phonenumber: getCompany.relatedphonecontacts[0]?.phonenumber,
      cinregistrationnumber: compData.cinregistrationnumber,
      registrationtype: compData.registrationtype,
      comppercentage: compData.comppercentage,
      gstrperiod: compData.gstrperiod,
      lut: compData.lut,
      lutbondvalidfrom: compData.lutbondvalidfrom,
      ewaybillflag: compData.ewaybillflag,
      gstapplicablefrom: compData.gstapplicablefrom,
      thresholdlimitcd: compData.thresholdlimitcd,
      thresholdlimitamount: compData.thresholdlimitamount,
      companylogourl: compData.thresholdlimitamount,
      msmetype: compData.msmetype,
      udhyamregno: compData.udhyamregno,
      udhyamdocs: compData.udhyamdocs,
      ewaybillstartdate: compData.ewaybillstartdate,
      minamountewayinter: compData.minamountewayinter,
      minamountewayintra: compData.minamountewayintra,
      einvoiceflag: compData.einvoiceflag,
      einvoicestartingdate: compData.einvoicestartingdate,
      gstcompensationcessflag: compData.gstcompensationcessflag,
      tradelicensenumber: compData.tradelicensenumber,
      tradelicensestartdate: compData.tradelicensestartdate,
      tradelicenseenddate: compData.tradelicenseenddate,
      cinregistrationdate: compData.cinregistrationdate,
      lastupdatedtimestamp: compData.lastupdatedtimestamp,
      stepscompleted: JSON.stringify(compData.stepscompleted),
    };
    try {
      const res = await API.graphql(
        graphqlOperation(createcompanydetails, {
          createCompanyDetailsInput: [companyFormData],
        })
      );

      const payload = {
        action: 'updateCredentials',
        data: {
          userName: userName.trim(),
          password: userPassword.trim(),
        },
      };
      const resvv = await axiosInstanceForLambda.post(API_ENDPOINTS.REACT_APP_EINVOICE_URL, payload);
      dispatch(fetchCompany());
    } catch (error) {
      console.log(error);
      setOpen(true);
      setLoading(false);
    }
  };
  const handleEimp = async () => {
    setBool(true);
    if (setBackdropOpen) {
      setBackdropOpen(true);
    }
    if (userName && userPassword) {
      setLoading(true);
      let payload;
      try {
        let ewayEinUrl;
        if (checkbox.includes('eway')) {
          ewayEinUrl = API_ENDPOINTS.REACT_APP_EWAYBILL_URL;
          payload = {
            action: 'validateCredentials',
            credentials: {
              userName: userName,
              password: userPassword,
            },
          };
        } else {
          ewayEinUrl = API_ENDPOINTS.REACT_APP_EINVOICE_URL;
          payload = {
            action: 'validateCredentials',
            data: {
              userName: userName,
              password: userPassword,
            },
          };

          // if (allSales === true && !rowData) {
          //   authOk();
          // }
        }
        const res = await axiosInstanceForLambda.post(ewayEinUrl, payload);
        if (res.status === 200) {
          onComplete && onComplete('success');
          // showSuccessSnackbar('Validated successfully');
          setOpen(false);
          if (rowData?.todo === 'cancel') {
            setCancelEInv(true);
          }
          //  else {

          // }

          dispatch(einvPreview({ preview: true, id: 0 }));
          dispatch(
            einvAuthData({
              userName: userName,
              password: userPassword,
            })
          );
          console.log('kkkk');
          // if (allSales === true) {
          if (connect === true) {
            companyUpdate();
          }
          if (allSales === true && rowData && !('irn' in rowData)) {
            authOk();
          }
          setOpen(false);
          setLoading(false);
          action('success', userName, userPassword);
          // setCancelEInv(true);
          // }
          // setPreviewOpen(true);
          dispatch(einvAuth(false));
        } else {
          onComplete && onComplete('failed');
          showWarningSnackbar('Please provide valid credentials');
        }
      } catch (error) {
        console.log(error, 'error');
        onComplete && onComplete('failed');
        const err =
          error?.response?.data?.details?.length > 0 || error?.response?.data?.message
            ? 'Invalid login credentials'
            : 'Something went wrong';
        showWarningSnackbar(err);
      } finally {
        setLoading(false);
        if (setBackdropOpen) {
          setBackdropOpen(false);
        }
      }
    }
  };
  console.log(connect, 'connect');
  return (
    <Box>
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={open}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
        onClose={handleClose}
      >
        <Fade in={open}>
          <Paper sx={style}>
            <Box
              sx={{
                backgroundColor: 'primary.main',
                padding: '5px 15px',
                display: 'flex',
                flexDirection: 'row',
              }}
            >
              <Box sx={{ flex: 1 }}>
                <Typography
                  sx={{
                    color: '#fff',
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                  }}
                >
                  Please Provide {checkbox === 'eway' ? 'E way bill' : 'E invoice'} Credentials
                  {/* {hsnParamsID === ""
                    ? page === "GOODS"
                      ? "Add HSN Code"
                      : page === "SERVICE"
                      ? "Add SA Code"
                      : "Add HSN/SA Code"
                    : "Edit HSN/SA Code"} */}
                  <IconButton aria-label="delete" onClick={handleClose}>
                    <CloseIcon sx={{ color: '#fff' }} />
                  </IconButton>
                </Typography>
              </Box>
            </Box>

            <Box
              sx={{
                padding: '15px',
                display: 'flex',
                flexDirection: 'column',
              }}
            >
              <TextField type="text" style={{ display: 'none' }} autoComplete="username" />
              <TextField type="password" style={{ display: 'none' }} autoComplete="new-password" />
              <TextField
                label="Enter user Name"
                value={userName}
                required={true}
                id="eusername"
                name="eusername"
                // defaultValue={" "}
                inputProps={{ autoComplete: 'off', name: 'field1' }}
                onChange={(event) => {
                  setUserName(event.target.value);
                }}
              />
              {bool === true && userName === '' && <p style={{ color: 'red' }}>Username is Required</p>}
              <TextField
                label="Enter Password"
                defaultValue={' '}
                inputProps={{ autoComplete: 'off', name: 'field2' }}
                value={userPassword}
                required={true}
                sx={{ marginTop: '10px' }}
                onChange={(event) => {
                  setUserPassword(event.target.value);
                }}
                type={showPassword ? 'text' : 'password'}
                InputProps={{
                  endAdornment: endAdornment,
                }}
              />
              {bool === true && userPassword === '' && <p style={{ color: 'red' }}>Password is Required</p>}
            </Box>
            <Box>
              <CheckBoxWithLabel
                label="Save & Connect permanently"
                id="connect"
                htmlFor="connect"
                checked={connect}
                onChange={(event) => setConnect((prev) => !prev)}
              />
            </Box>
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'space-between',
                flexDirection: { xs: 'column', sm: 'row' },
              }}
            >
              {/* <Button
                onClick={handleClose}
                variant="outlined"
                sx={{ flex: 1, margin: "10px", fontSize: "12px" }}
              >
                Submit
              </Button> */}
              <LoadingButton
                loading={loading}
                disableRipple={true}
                onClick={handleEimp}
                variant="contained"
                sx={{ flex: 1, margin: '10px', fontSize: '12px' }}
              >
                Submit
              </LoadingButton>
            </Box>
          </Paper>
        </Fade>
      </Modal>
    </Box>
  );
}

export default EInvAuth;
